import RestService from "./RestService";

export default class AiDebugLogService extends RestService {
  constructor() {
    super("ai-debug-logs");
  }

  list(limit = 50, offset = 0) {
    return super.executeGet(
      this.baseUrl +
        `/v3/api/planning/ai-debug-logs?limit=${limit}&offset=${offset}`
    );
  }

  getById(debugId) {
    return super.executeGet(
      this.baseUrl + `/v3/api/planning/ai-debug-logs/${debugId}`
    );
  }
} 